import { manager1 } from 'app/mocks/data/park/managers/list'

import { KonsoleUser } from 'app/types/users/konsole'

export const admin1: KonsoleUser = {
    id: 101,
    username: 'admin1',
    email: 'admin1@e-thik.com',
    last_name: 'DUPONT',
    first_name: 'Louis',
    is_staff: true,
    profil: {
        client: [manager1],
        avatar: 'https://apis-dev.e-thik.com/media/avatars/default.png',
    },
    groups: [],
}
